const setPartyId = state => state.partyId;
const partyCustomerTabValue = state => state.customerTabValue;
export default {
  setPartyId,
  partyCustomerTabValue
};
